export default __webpack_public_path__ + "b0d6b8968898d24af3242892d1ff80fd.png";